import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L11 11M11 1L1 11", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgCloseIcon);
export default ForwardRef;
